import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ConfigResourceService } from '../../services/config-resource.service';
import { ResourceTemplateComponent } from '../../shared/resource-template/resource-template.component';

@Component({
  selector: 'app-accessibility-statement',
  templateUrl: './accessibility-statement.component.html',
  styleUrls: ['./accessibility-statement.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatDialogModule, ResourceTemplateComponent]
})
export class AccessibilityStatementComponent implements OnInit, OnDestroy {
  @Input() footerStickyEnabled: boolean = true;

  accessibilityContent: string = '';
  private readonly subscriptions: Subscription = new Subscription();

  constructor(private readonly configService: ConfigResourceService, private readonly cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.accessibilityContent = this.configService.getProcessedResourceValue<string>(
              'Spa_Site_Accessibility_Body',
              '<h1>[[Spa_Site_Accessibility]]</h1>'
            );
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
